import debounce from "lodash.debounce";

window.StudentDashboard = new (function () {
  // TODO: Check why the all selects are in resize block
  this.setSelects = () => {
    let wrapper = $("#student-dashboard-wrapper");
    // reset select2 value to prevent bug with firefox inputs caching
    $("#exam_name", wrapper).select2({
      minimumResultsForSearch: Infinity,
      allowClear: false,
      templateResult: function (examTitle) {
        if (!examTitle.id) return examTitle.text;
        if (examTitle.element.dataset.inClass == "true") return $(`<span>${examTitle.text}</span>`);
        return $(`<span class="fw-600">${examTitle.text}</span>`);
      },
    });
  };

  $(document).on("show.bs.modal", "#addStudentTargetsModal", function () {
    $(".st-grade").select2({
      placeholder: "Please Select",
      minimumResultsForSearch: Infinity,
      height: "28px",
    });
  });

  this.setHeight = () => {
    let wrapper = $("#students-list-wrapper");

    if (!wrapper || !wrapper.length) return;

    if ($("#student-results").length) {
      $("#students-list-wrapper").outerHeight($("#student-results").outerHeight());
    } else {
      $("#students-list-wrapper").outerHeight(600);
    }
  };

  this.initStudentResults = () => {
    $(document).on("change", ".recent-results-filter #exam_name", function () {
      let title = $(this).find(":selected").data("title");
      let academic_year = $(this).find(":selected").data("academic-year");

      $(".recent-results-filter #exam_title").val(title);
      $(".recent-results-filter #exam_academic_year").val(academic_year);

      $(this).closest("form").submit();
    });

    if ($(".recent-results-filter #exam_name").length > 0) {
      let last_option = $(".recent-results-filter #exam_name option:last").val();

      $(".recent-results-filter #exam_name").val(last_option).trigger("change");
    }

    if ($(".student-results #subject_name").length > 0) {
      $(".student-results #subject_name").closest("form").submit();
    }
  };

  this.bindEvents = () => {
    $("#target-descriptor-modal").on("show.bs.modal", positionTargetDescriptorModal);
    $(window).on("resize", debounce(positionTargetDescriptorModal, 500));
  };

  function positionTargetDescriptorModal() {
    var targetModal = document.querySelector("#addStudentTargetsModal");
    var descriptorModal = document.querySelector("#target-descriptor-modal .modal-dialog");
    if (!$(targetModal) || !$(targetModal).length || !$(descriptorModal) || !$(descriptorModal).length) return;

    var offsetTop =
      targetModal.querySelector(".modal-dialog").offsetTop + targetModal.querySelector(".modal-content").offsetTop;
    var offsetLeft =
      targetModal.querySelector(".modal-dialog").offsetLeft + targetModal.querySelector(".modal-dialog").offsetWidth;

    descriptorModal.style.left = `${offsetLeft}px`;
    descriptorModal.style.top = `${offsetTop}px`;
  }
})();
